/* istanbul ignore file */
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import type { EventsMap } from '@noths/polaris-client-next-redux';

import { productListClick } from 'src/components/organisms/ProductList/modules/actions';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getCategoryIdFromCanonicalFilters } from 'src/redux/productsQuery/utils/getCategoryIdFromCanonicalFilters';
import { getPartnerShortcodeFromCanonicalFilters } from 'src/redux/productsQuery/utils/getPartnerShortcodeFromCanonicalFilters';
import { getProductClickTrackingEvent } from 'src/tracking/events/productClick';
import { getFieldObjectList, getProductFieldObject } from 'src/utils/googleAnalytics';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [productListClick.type]: (state, _nextState, action) => {
    const {
      payload: { destinationUrl, linkOpensInSameWindow, productCode, productUrl },
    } = action as ReturnType<typeof productListClick>;
    const { navigation, products, productsQuery } = state;
    const { pages, productsReturnedCount } = products;
    const { pageType } = navigation;
    const categoryId = getCategoryIdFromCanonicalFilters(productsQuery.canonicalFilters);
    const partnerShortcode = getPartnerShortcodeFromCanonicalFilters(
      productsQuery.canonicalFilters,
    );

    const clickedProduct = Object.values(pages)
      .flat()
      .find((prod) => prod.code === productCode)!;

    const event = getProductClickTrackingEvent({
      eventCategory: 'Product listings',
      destinationUrl,
      eventLabel: 'null',
      actionFieldList: getFieldObjectList(
        clickedProduct,
        productsQuery.searchTerm!,
        pageType,
        clickedProduct.isExpandedSearch ? ' - expanded' : undefined,
        partnerShortcode || undefined,
      ),
      products: [
        getProductFieldObject(
          clickedProduct,
          pages,
          productsReturnedCount,
          categoryId || undefined,
          pageType,
        ),
      ],
    });

    sendGAEvent(event).then(() => {
      if (linkOpensInSameWindow) {
        window.location.assign(productUrl);
      }
    });
  },
};
